import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Row,
  Col,
  Form,
  Select,
  Input,
  InputNumber,
  Button,
  Typography,
} from 'antd';
import { DeleteOutlined, InboxOutlined } from '@ant-design/icons';

const { Text } = Typography;

import { measurementUnits } from '../../shared/utils';

const LineItemRow = styled(Row)`
  .ant-form-item-label {
    line-height: 14px;
  }
`;

const LineItemActionWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
`;

const NoFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LineItem = ({ item, onRemoveItem, partOptions, onChange }) => {
  const totalCost = (item.quantity || 0) * (item.unitCost || 0);

  const filterOption = (input, option) => {
    return (
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  };

  const noPartFound = (
    <NoFoundContainer>
      <InboxOutlined style={{ fontSize: '24px' }} />
      <Text level={4}>No Data</Text>
    </NoFoundContainer>
  );

  const onSearchPart = (value) => {
    // setCurrentSearchPart(value);
  };

  return (
    <LineItemRow gutter={16}>
      <Col span={6}>
        {item.type === 'part' ? (
          <Form.Item label="Part">
            <Select
              style={{ width: '100%' }}
              placeholder="Select a Part"
              optionFilterProp="children"
              value={item.entityId}
              onChange={(val) => onChange(item, 'entityId', val)}
              onSearch={(value) => onSearchPart(value)}
              showSearch
              filterOption={filterOption}
              notFoundContent={noPartFound}
              data-testid="part-select"
            >
              {partOptions}
            </Select>
          </Form.Item>
        ) : (
          <Form.Item label="Service">
            <Input
              value={item.entityId}
              onChange={(event) =>
                onChange(item, 'entityId', event.target.value)
              }
              data-testid="service-input"
            />
          </Form.Item>
        )}
      </Col>
      <Col span={3}>
        <Form.Item label="Qty">
          <Input
            value={item.quantity}
            onChange={(event) => onChange(item, 'quantity', event.target.value)}
            data-testid="quantity-input"
          />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Meas. Unit">
          <Select
            style={{ width: '100%' }}
            placeholder="-"
            value={item.volumeUnit}
            onChange={(val) => onChange(item, 'volumeUnit', val)}
            data-testid="meas-unit-select"
          >
            <Select.Option value="">-</Select.Option>
            {measurementUnits.map((unit) => (
              <Select.Option key={unit} value={unit}>
                {unit}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Unit Cost">
          <InputNumber
            style={{
              width: '100%',
            }}
            value={item.unitCost}
            formatter={(value) =>
              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            onChange={(value) => onChange(item, 'unitCost', value)}
            data-testid="unit-cost-input"
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Amount">
          <InputNumber
            style={{
              width: '100%',
            }}
            disabled={true}
            readOnly={true}
            value={totalCost}
            formatter={(value) =>
              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            data-testid="amount-input"
          />
        </Form.Item>
      </Col>
      <Col span={1}>
        <LineItemActionWrapper>
          <Button
            type="link"
            icon={<DeleteOutlined />}
            style={{ color: 'red' }}
            onClick={() => {
              onRemoveItem(item);
            }}
            data-testid="delete-button"
          />
        </LineItemActionWrapper>
      </Col>
    </LineItemRow>
  );
};

LineItem.propTypes = {
  item: PropTypes.object,
  onRemoveItem: PropTypes.func,
  onChange: PropTypes.func,
  partOptions: PropTypes.array,
};

export default LineItem;
